import React, { useContext } from 'react';
import { DraggableDialog, HCPCSIcon } from '@mummssoftware/common-ui';
import { hasTimerDuration } from '@mummssoftware/utils/utils';
import {
  HCPCSGlobalContext,
  GlobalContext,
  VisitsGlobalContext,
  SET_EDITING_PAST_VISIT,
  SET_SHOW_HCPCS,
} from '@mummssoftware/global-context';
import { EditVisitContent } from './EditVisitContent';
import { AppContext } from '../../../context';
import defaults from '../../../translations/en.json';

type EditVisitConfirmationProps = {
  open: boolean;
  setClosed: () => void;
  onEdit: () => void;
  onRecord: () => void;
  data: Record<string, any>;
  isHopeVisit?: boolean;
  getAttributes: () => JSX.Element;
};

export const EditVisitConfirmation = ({
  open,
  setClosed,
  onEdit,
  onRecord,
  data,
  isHopeVisit,
  getAttributes,
}: EditVisitConfirmationProps) => {
  const { dispatchHCPCS, hcpcsPermission, resetHCPCSPerms } = useContext(
    HCPCSGlobalContext,
  );
  const {
    travelMileage,
    transitFees,
    travelDuration,
    tollsFee,
    editTime,
    ccTime,
    timerDuration,
    startTime,
  } = useContext(VisitsGlobalContext);

  const active =
    travelMileage ||
    transitFees ||
    travelDuration ||
    tollsFee ||
    editTime ||
    startTime ||
    ccTime ||
    hasTimerDuration(timerDuration);
  const hasPerms = (hcpcsPermission && hcpcsPermission.ishcpcsallowed) || false;
  const showHCPCSIcon = hasPerms;

  const globalContext = useContext(GlobalContext);
  const {
    agency,

    pim,
  } = useContext(AppContext);
  const onClickHCPCS = async () => {
    const pimVisit = await pim.getPatientVisit(data.patient_id, data, agency);
    globalContext.dispatch({
      type: SET_EDITING_PAST_VISIT,
      payload: pimVisit,
    });
    dispatchHCPCS({
      type: SET_SHOW_HCPCS,
      payload: true,
    });
  };

  const onCloseHCPCS = () => {
    resetHCPCSPerms();
    setClosed();
  };

  return (
    <DraggableDialog
      title={defaults.editVisitMsg}
      handleClick={onCloseHCPCS}
      open={open}
      hcpcs={showHCPCSIcon ? <HCPCSIcon onClick={onClickHCPCS} /> : undefined}
      attributes={getAttributes()}
      // prevent outside elements to be clickable
      disableInteraction
      noIcon={!!active}
    >
      <EditVisitContent
        data={data}
        isHopeVisit={isHopeVisit}
        setClosed={onCloseHCPCS}
        onEdit={onEdit}
        onRecord={onRecord}
      />
    </DraggableDialog>
  );
};
